import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'components/base/Button';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ForgotPasswordForm = ({
    layout
}: {
    layout?: 'simple' | 'card' | 'split';
}) => {
    return (
        <div className={classNames({ 'px-xxl-5': !(layout === 'split') })}>
            <div
                className={classNames('text-center', { 'mb-6': !(layout === 'split') })}
            >
                <h4 className="text-body-highlight">Esqueceu sua senha?</h4>
                <p className="text-body-tertiary mb-5"></p>
                <p className="text-body-tertiary mb-5">
                    Insira seu e-mail abaixo e enviaremos um link para redefinir sua senha
                </p>
                <Form className="d-flex align-items-center mb-5">
                    <Form.Control
                        type="email"
                        id="email"
                        className="flex-1"
                        placeholder="Email"
                    />
                    <Button
                        variant="primary"
                        className="ms-2"
                        endIcon={<FontAwesomeIcon icon={faChevronRight} className="ms-2" />}
                    >
                        Enviar
                    </Button>
                </Form>
                {/* <Link to="#!" className="fs-9 fw-bold">
          Still having problems?
        </Link> */}
            </div>
        </div>
    );
};

export default ForgotPasswordForm;
